import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=ff4c6fe8&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=ts"
export * from "./Notice.vue?vue&type=script&lang=ts"
import style0 from "./Notice.vue?vue&type=style&index=0&id=ff4c6fe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4c6fe8",
  null
  
)

export default component.exports